(() => {
    // Wrap tables in richtext blocks with a scrollable container for mobile
    document.querySelectorAll('.js-richtext table').forEach(table => {
        if (table.parentElement.classList.contains('table-scroll')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'table-scroll';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();